var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBuying(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.67844 13.1279H2.10467C1.79044 13.1279 1.58008 12.918 1.58008 12.6033V10.6623C1.58008 10.5049 1.63254 10.3475 1.78991 10.2426L2.10467 10.0328V9.98033H2.15713L15.4293 0.118033C15.6391 -0.0393443 15.8489 -0.0393443 16.0588 0.118033L29.6981 10.2426C29.8555 10.3475 29.9079 10.5049 29.9079 10.6623V12.6033C29.9079 12.918 29.6981 13.1279 29.3834 13.1279H27.8096V19.9475H26.7604V13.1279H4.72762V19.9475H3.67844V13.1279ZM28.8588 10.9246L15.744 1.16721L3.88827 9.98033H23.6129V11.0295H2.62926V12.0787H4.20303H27.285H28.8588V10.9246Z",
    fill: "#B2D235"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.6953,
    y: 4.73438,
    width: 2.09836,
    height: 1.04918,
    fill: "#B2D235"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1211,
    y: 6.83301,
    width: 5.2459,
    height: 1.04918,
    fill: "#B2D235"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.77734,
    y: 14.1768,
    width: 1.04918,
    height: 1.04918,
    fill: "#B2D235"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.875,
    y: 14.1768,
    width: 1.04918,
    height: 1.04918,
    fill: "#B2D235"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97266,
    y: 14.1768,
    width: 1.04918,
    height: 1.04918,
    fill: "#B2D235"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0723,
    y: 14.1768,
    width: 1.04918,
    height: 1.04918,
    fill: "#B2D235"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1699,
    y: 14.1768,
    width: 1.04918,
    height: 1.04918,
    fill: "#B2D235"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2695,
    y: 14.1768,
    width: 1.04918,
    height: 1.04918,
    fill: "#B2D235"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3672,
    y: 14.1768,
    width: 1.04918,
    height: 1.04918,
    fill: "#B2D235"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4648,
    y: 14.1768,
    width: 1.04918,
    height: 1.04918,
    fill: "#B2D235"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5645,
    y: 14.1768,
    width: 1.04918,
    height: 1.04918,
    fill: "#B2D235"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6621,
    y: 14.1768,
    width: 1.04918,
    height: 1.04918,
    fill: "#B2D235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3829 30.4391V23.8293L30.0649 24.5113L30.7993 23.7769L29.2255 22.2031C29.0157 21.9932 28.7009 21.9932 28.4911 22.2031L26.9173 23.7769L27.6518 24.5113L28.3337 23.8293V30.4391H23.0878V18.5834L23.7698 19.2654L24.5042 18.531L22.9305 16.9572C22.7206 16.7473 22.4059 16.7473 22.196 16.9572L20.6223 18.531L21.3567 19.2654L22.0386 18.5834V30.4391H9.44848V18.5834L10.1304 19.2654L10.8649 18.531L9.29111 16.9572C9.08127 16.7473 8.76651 16.7473 8.55668 16.9572L6.98291 18.531L7.71733 19.2654L8.3993 18.5834V30.4391H3.1534V23.8293L3.83537 24.5113L4.56979 23.7769L2.99602 22.2031C2.78619 21.9932 2.47143 21.9932 2.2616 22.2031L0.687827 23.7769L1.42225 24.5113L2.10422 23.8293V30.4391H0.00585938V31.4883H31.4813V30.4391H29.3829Z",
    fill: "#B2D235"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2187 18.8982H16.2678C17.1596 18.8982 17.8416 19.5801 17.8416 20.4719H18.8908C18.8908 19.0031 17.7367 17.849 16.2678 17.849V16.7998H15.2187V17.849C13.7498 17.849 12.5957 19.0031 12.5957 20.4719C12.5957 21.9408 13.7498 23.0949 15.2187 23.0949H16.2678C17.1596 23.0949 17.8416 23.7769 17.8416 24.6687C17.8416 25.5605 17.1596 26.2424 16.2678 26.2424H15.2187C14.3269 26.2424 13.6449 25.5605 13.6449 24.6687H12.5957C12.5957 26.1375 13.7498 27.2916 15.2187 27.2916V28.3408H16.2678V27.2916C17.7367 27.2916 18.8908 26.1375 18.8908 24.6687C18.8908 23.1998 17.7367 22.0457 16.2678 22.0457H15.2187C14.3269 22.0457 13.6449 21.3637 13.6449 20.4719C13.6449 19.5801 14.3269 18.8982 15.2187 18.8982Z",
    fill: "#B2D235"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBuying);
export default __webpack_public_path__ + "static/media/home-buying.43ce8294.svg";
export { ForwardRef as ReactComponent };